export enum PermissionsKeys {
  PRE_QUALIFICATION = 'pre_qualification',
  CREATE_INVITE = 'create_invite',
  UPDATE_INVITE = 'update_invite',
  SHOW_INVITE = 'show_invite',
  DELETE_DRAFT_INVITE = 'delete_draft_invite',
  LIST_INVITE = 'list_invite',
  SEND_INVITE = 'send_invite',
  RESEND_INVITE = 'resend_invite',
  SEND_EMAIL_PREVIEW_INVITE = 'send_email_preview_invite',
  ARCHIVE_INVITE = 'archive_invite',
  DELETE_ARCHIVE_INVITE = 'delete_archive_invite',
  MERGE_TEMPLATE_INVITE = 'merge_template_invite',
  CREATE_CONTACT_INVITE = 'create_contact_invite',
  DELETE_CONTACT_INVITE = 'delete_contact_invite',
  SHOW_CONTACT_GROUP = 'show_contact_group',
  DELETE_CONTACT_GROUP = 'delete_contact_group',
  UPDATE_CONTACT_GROUP = 'update_contact_group',
  LIST_CONTACT_GROUP = 'list_contact_group',
  LIST_CONTACT_GROUPS = 'list_contact_groups',
  LIST_CONTACTS_IN_CONTACT_GROUP = 'list_contacts_in_contact_group',
  REMOVE_CONTACT_FROM_CONTACT_GROUP = 'remove_contact_from_contact_group',
  CREATE_CONTACT_GROUP = 'create_contact_group',
  CREATE_INVITE_REQUEST = 'create_invite_request',
  UPDATE_INVITE_REQUEST = 'update_invite_request',
  DELETE_INVITE_REQUEST = 'delete_invite_request',
  LIST_INVITE_REQUEST = 'list_invite_request',
  ACCEPT_INVITE_REQUEST = 'accept_invite_request',
  REVISION_INVITE_REQUEST = 'revision_invite_request',
  CREATE_INVITE_REQUEST_CONTACT = 'create_invite_request_contact',
  DELETE_INVITE_REQUEST_CONTACT = 'delete_invite_request_contact',
  CREATE_CONTACT = 'create_contact',
  UPDATE_CONTACT = 'update_contact',
  SHOW_CONTACT = 'show_contact',
  DELETE_CONTACT = 'delete_contact',
  LIST_CONTACT = 'list_contact',
  RESTORE_CONTACT = 'restore_contact',
  IMPORT_CONTACT = 'import_contact',
  LOAD_TEMPLATE = 'load_template',
  UPLOAD_FILE = 'upload_file',
  DELETE_FILE = 'delete_file',
  PREVIEW_FILE = 'preview_file',
  DOWNLOAD_FILE = 'download_file',
  DOWNLOAD_ZIP_FILE = 'download_zip_file',
  FILE_SIGNED_URL = 'file_signed_url',
  CREATE_COLLATE = 'create_collate',
  LIST_COLLATE = 'list_collate',
  LIST_COLLATE_HISTORY = 'list_collate_history',
  CREATE_LIVEFORM_FIELD = 'create_liveform_field',
  SHOW_LIVEFORM_FIELD = 'show_liveform_field',
  DETECT_LIVEFORM_FIELD = 'detect_liveform_field',
  CREATE_LIVEFORM_VALUE = 'create_liveform_value',
  SHOW_LIVEFORM_VALUE = 'show_liveform_value',
  DELETE_LIVEFORM_VALUE = 'delete_liveform_value',
  CREATE_FOLLOW_UP = 'create_follow_up',
  UPDATE_FOLLOW_UP = 'update_follow_up',
  SHOW_FOLLOW_UP = 'show_follow_up',
  LIST_FOLLOW_UP = 'list_follow_up',
  SEND_FOLLOW_UP = 'send_follow_up',
  CREATE_TEMPLATE = 'create_template',
  UPDATE_TEMPLATE = 'update_template',
  RENAME_TEMPLATE = 'rename_template',
  SHOW_TEMPLATE = 'show_template',
  DELETE_TEMPLATE = 'delete_template',
  LIST_TEMPLATE = 'list_template',
  DUPLICATE_TEMPLATE = 'duplicate_template',
  LIST_TEMPLATE_REQUEST = 'list_template_request',
  CREATE_TEMPLATE_REQUEST = 'create_template_request',
  UPDATE_TEMPLATE_REQUEST = 'update_template_request',
  DELETE_TEMPLATE_REQUEST = 'delete_template_request',
  CREATE_BRANDING = 'create_branding',
  UPDATE_BRANDING = 'update_branding',
  LIST_BRANDING = 'list_branding',
  CREATE_NAMING_CONVENTION = 'create_naming_convention',
  UPDATE_NAMING_CONVENTION = 'update_naming_convention',
  SHOW_NAMING_CONVENTION = 'show_naming_convention',
  LIST_NAMING_CONVENTION = 'list_naming_convention',
  CREATE_CUSTOM_DOMAIN = 'create_custom_domain',
  SHOW_CUSTOM_DOMAIN = 'show_custom_domain',
  DELETE_CUSTOM_DOMAIN = 'delete_custom_domain',
  SHOW_ACCOUNT_SSO = 'show_account_sso',
  SHOW_ORGANISATION_SSO = 'show_organisation_sso',
  UPDATE_SSO = 'update_sso',
  TEST_EMAIL_CUSTOM_DOMAIN = 'test_email_custom_domain',
  TEST_SMTP_CUSTOM_DOMAIN = 'test_smtp_custom_domain',
  OMNI_SEARCH = 'omni_search',
  LIST_ROLE = 'list_role',
  CREATE_MESSAGE = 'create_message',
  LIST_MESSAGE = 'list_message',
  CREATE_USER = 'create_user',
  UPDATE_USER = 'update_user',
  SHOW_USER = 'show_user',
  LIST_USER = 'list_user',
  CREATE_TEAM = 'create_team',
  UPDATE_TEAM = 'update_team',
  SHOW_TEAM = 'show_team',
  LIST_TEAM = 'list_team',
  DELETE_TEAM = 'delete_team',
  LIST_TEAM_USER = 'list_team_user',
  DELETE_TEAM_USER = 'delete_team_user',
  CREATE_INVITE_CONTACT_REQUEST = 'create_invite_contact_request',
  DELETE_INVITE_CONTACT_REQUEST = 'delete_invite_contact_request',
  LIST_WATCHER = 'list_watcher',
  WATCH_INVITE = 'watch_invite',
  UNWATCH_INVITE = 'unwatch_invite',
  ACTIVITY_LOG_USER = 'activity_log_user',
  DOWNLOAD_ACTIVITY_LOG_USER = 'download_activity_log_user',
  LIST_INTEGRATION_SITE = 'list_integration_site',
  // Google Drive User Level Permissions
  CREATE_GOOGLE_DRIVE_INTEGRATION = 'create_google_drive_integration',
  SHOW_GOOGLE_DRIVE_INTEGRATION = 'show_google_drive_integration',
  UPDATE_GOOGLE_DRIVE_INTEGRATION = 'update_google_drive_integration',
  DELETE_GOOGLE_DRIVE_INTEGRATION = 'delete_google_drive_integration',
  CREATE_GOOGLE_DRIVE_FOLDER = 'create_google_drive_folder',
  LIST_GOOGLE_DRIVE_FOLDER = 'list_google_drive_folder',
  LINK_GOOGLE_DRIVE_FOLDER = 'link_google_drive_folder',
  RESYNC_GOOGLE_DRIVE = 'resync_google_drive',
  // OneDrive User Level Permissions
  CREATE_ONEDRIVE_BUSINESS_INTEGRATION = 'create_onedrive_business_integration',
  SHOW_ONEDRIVE_BUSINESS_INTEGRATION = 'show_onedrive_business_integration',
  UPDATE_ONEDRIVE_BUSINESS_INTEGRATION = 'update_onedrive_business_integration',
  DELETE_ONEDRIVE_BUSINESS_INTEGRATION = 'delete_onedrive_business_integration',
  CREATE_ONEDRIVE_BUSINESS_FOLDER = 'create_onedrive_business_folder',
  LIST_ONEDRIVE_BUSINESS_FOLDER = 'list_onedrive_business_folder',
  LINK_ONEDRIVE_BUSINESS_FOLDER = 'link_onedrive_business_folder',
  RESYNC_ONEDRIVE_BUSINESS = 'resync_onedrive_business',
  // Box User Level Permissions
  CREATE_BOX_INTEGRATION = 'create_box_integration',
  SHOW_BOX_INTEGRATION = 'show_box_integration',
  UPDATE_BOX_INTEGRATION = 'update_box_integration',
  DELETE_BOX_INTEGRATION = 'delete_box_integration',
  CREATE_BOX_FOLDER = 'create_box_folder',
  LIST_BOX_FOLDER = 'list_box_folder',
  LINK_BOX_FOLDER = 'link_box_folder',
  RESYNC_BOX = 'resync_box',
  // Google Drive Account Level Permissions
  CREATE_GOOGLE_DRIVE_ACCOUNT_INTEGRATION = 'create_google_drive_account_integration',
  SHOW_GOOGLE_DRIVE_ACCOUNT_INTEGRATION = 'show_google_drive_account_integration',
  UPDATE_GOOGLE_DRIVE_ACCOUNT_INTEGRATION = 'update_google_drive_account_integration',
  DELETE_GOOGLE_DRIVE_ACCOUNT_INTEGRATION = 'delete_google_drive_account_integration',
  CREATE_GOOGLE_DRIVE_ACCOUNT_FOLDER = 'create_google_drive_account_folder',
  LIST_GOOGLE_DRIVE_ACCOUNT_FOLDER = 'list_google_drive_account_folder',
  LINK_GOOGLE_DRIVE_ACCOUNT_FOLDER = 'link_google_drive_account_folder',
  RESYNC_GOOGLE_DRIVE_ACCOUNT = 'resync_google_drive_account',
  // Box Account Level Permissions
  CREATE_BOX_ACCOUNT_INTEGRATION = 'create_box_account_integration',
  SHOW_BOX_ACCOUNT_INTEGRATION = 'show_box_account_integration',
  UPDATE_BOX_ACCOUNT_INTEGRATION = 'update_box_account_integration',
  DELETE_BOX_ACCOUNT_INTEGRATION = 'delete_box_account_integration',
  CREATE_BOX_ACCOUNT_FOLDER = 'create_box_account_folder',
  LIST_BOX_ACCOUNT_FOLDER = 'list_box_account_folder',
  LINK_BOX_ACCOUNT_FOLDER = 'link_box_account_folder',
  RESYNC_BOX_ACCOUNT = 'resync_box_account',
  // Sharepoint Account Level Permissions
  CREATE_SHAREPOINT_INTEGRATION = 'create_sharepoint_integration',
  SHOW_SHAREPOINT_INTEGRATION = 'show_sharepoint_integration',
  UPDATE_SHAREPOINT_INTEGRATION = 'update_sharepoint_integration',
  DELETE_SHAREPOINT_INTEGRATION = 'delete_sharepoint_integration',
  CREATE_SHAREPOINT_FOLDER = 'create_sharepoint_folder',
  LIST_SHAREPOINT_FOLDER = 'list_sharepoint_folder',
  LINK_SHAREPOINT_FOLDER = 'link_sharepoint_folder',
  RESYNC_SHAREPOINT = 'resync_sharepoint',
  LIST_INTEGRATION_DOCUMENT_LIBRARY = 'list_integration_document_library',
  // HubSpot Account Level Permissions
  GET_EMBEDDED_HUBSPOT_LINK = 'get_embedded_hubspot_link',
  // Salesforce Account Level Permissions
  GET_EMBEDDED_SALESFORCE_LINK = 'get_embedded_salesforce_link',

  GENERATE_HISTORY_REPORT_INVITE = 'generate_history_report_invite',
  DOWNLOAD_HISTORY_REPORT_INVITE = 'download_history_report_invite',
  DEACTIVATE_USER = 'deactivate_user',
  CREATE_VIEW = 'create_view',
  UPDATE_VIEW = 'update_view',
  SHOW_VIEW = 'show_view',
  DELETE_VIEW = 'delete_view',
  LIST_VIEW = 'list_view',
  SET_DEFAULT_VIEW = 'set_default_view',
  UNARCHIVE_INVITE = 'unarchive_invite',
  DUPLICATE_INVITE = 'duplicate_invite',
  REORDER_REQUEST_INVITE = 'reorder_request_invite',
  REORDER_REQUEST_TEMPLATE = 'reorder_request_template',
  REORDER_FOLLOW_UP = 'reorder_follow_up',
  SHOW_NOTIFICATION_TEMPLATE = 'show_notification_template',
  LIST_NOTIFICATION_PLACEHOLDER = 'list_notification_placeholder',
  UPSERT_NOTIFICATION_TEMPLATE = 'upsert_notification_template',
  CREATE_ROLE = 'create_role',
  COPY_ROLE = 'copy_role',
  UPDATE_ROLE = 'update_role',
  DELETE_ROLE = 'delete_role',
  RESYNC_INVITE = 'resync_invite',
  COMPLETE_INVITE = 'complete_invite',
  SHOW_MANAGEMENT_INSIGHTS = 'show_management_insights',
  SHOW_REPORTING = 'show_reporting',
  UPDATE_INVITE_ASSIGNEE = 'update_invite_assignee',
  SHOW_INVITE_ASSIGNEE = 'show_invite_assignee',
  UPDATE_INVITE_TEAM = 'update_invite_team',
  SHOW_INVITE_TEAM = 'show_invite_team',
  SHOW_DATA_RETENTION = 'show_data_retention',
  UPDATE_DATA_RETENTION = 'update_data_retention',
  UPDATE_PORTAL_AUTHENTICATION = 'update_portal_authentication_settings',
  SHOW_PORTAL_AUTHENTICATION = 'show_portal_authentication_settings',
  SHOW_RETURNED_REQUESTS_METRICS = 'show_returned_requests_metrics',
  SHOW_USERS_METRICS = 'show_users_metrics',
  SHOW_SMS_METRICS = 'show_sms_metrics',
  SHOW_STORAGE_METRICS = 'show_storage_metrics',
  SHOW_WORKATO_CUSTOMER_USAGE = 'show_workato_customer_usage',
  LIST_BILLING_USERS = 'list_billing_users',
  STORE_BILLING_USER = 'store_billing_user',
}
